export const initOnboardingStepTwo = () => {
  if (!document.querySelector('form[name="app_organization_onboarding_password"]')) {
    return;
  }

  const password = document.getElementById('app_organization_onboarding_password_plainPassword_first');
  const passwordConfirmation = document.getElementById('app_organization_onboarding_password_plainPassword_second');
  const submit = document.getElementById('app_organization_onboarding_password_save');

  const form = document.querySelector('form[name="app_organization_onboarding_password"]');

  function validate() {
    submit.disabled = password.value.trim().length === 0 || passwordConfirmation.value.trim().length === 0;
  }

  [ password, passwordConfirmation ].forEach((input) => {
    [ 'change', 'input' ].forEach((event) => {
      input.addEventListener(event, () => {
        validate();
      });
    });
  });

  form.addEventListener('submit', () => {
    submit.disabled = true;
    submit.classList.add('loading-btn');
  });

  validate();
};
